import { render } from "./Question.vue?vue&type=template&id=3b51c5a3&scoped=true"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"

import "./Question.vue?vue&type=style&index=0&id=3b51c5a3&scoped=true&lang=css"

import exportComponent from "/Users/walt/WORK/school/portfolio/s1-crypto-prng/prng/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b51c5a3"]])

export default __exports__